import { request } from '@/shared/api/request'

export const returnResult = (payload, captcha) => {
	return request({ url: `/selftest/save/returnResult?ignoreCaptcha=false&captcha=${captcha}`, method: 'POST', data: payload })
}
